
export default function AboutSection() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="px-6 lg:px-12 max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl lg:text-5xl font-['Fraunces'] font-semibold text-gray-900 mb-6">
              I'm Here for You
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Ready to explore healing that helps you remember who you are underneath it all? With over 15 years of experience in therapeutic massage and Chinese medicine, I'm dedicated to helping you achieve optimal wellness.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              My practice combines ancient Eastern healing wisdom with modern therapeutic techniques to address your unique needs. Whether you're seeking relief from chronic pain, stress reduction, or simply a moment of peace, I'm here to support your journey.
            </p>
            <div className="bg-teal-50 border-l-4 border-teal-700 p-6 rounded-r-lg mb-8">
              <p className="text-teal-900 font-semibold text-lg">
                <strong>FREE 15-minute consultation</strong> for all new clients
              </p>
            </div>
            <div className="grid grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-teal-700 mb-2">15+</div>
                <div className="text-sm text-gray-600">Years of Experience</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-teal-700 mb-2">2000+</div>
                <div className="text-sm text-gray-600">Clients Treated</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-teal-700 mb-2">98%</div>
                <div className="text-sm text-gray-600">Satisfaction Rate</div>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/172341dc8de65c6ed0480d2674e5ebed.jpg"
                alt="Professional Massage Therapist"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-lg max-w-xs">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full">
                  <i className="ri-award-line text-2xl text-teal-700"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Certified Professional</div>
                  <div className="text-sm text-gray-600">Licensed Therapist</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
